// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CurrencyType } from "@eisinc/App/Handlers/LoadSession";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xCurrenciesStateType = Readonly<{
    currenciesState: CurrencyType[];
    
}>;

export const initilCurrenciesState: xCurrenciesStateType = {
    currenciesState: [],
};
const reducer = {
    "xCurrencies/get": (draft: Draft<xCurrenciesStateType>, action: { currenciesState: CurrencyType[] }) => {
        draft.currenciesState = action.currenciesState
    },
};

const xLoadCurrencies = createTypedReducerWithImmer(initilCurrenciesState, reducer);

(reducers as any).xLoadCurrencies = xLoadCurrencies;

export type xLoadCurrenciesState = {
    xLoadCurrencies: xCurrenciesStateType;
} & ApplicationState;

type xLoadCurrenciesReducers = {
    [key: string]: typeof xLoadCurrencies;
};

export type xLoadCurrenciesReducersActions = Parameters<xLoadCurrenciesReducers[keyof xLoadCurrenciesReducers]>[1] | AnyAction;
